import request from '@/utils/request'

// 分页查询房东交租记录信息
export function getPageList(params) {
  return request({
    url: '/hrApi/ownerRentRecord',
    method: 'get',
    params: params
  })
}

// 获取房东交租记录列表
export function getList(params) {
  return request({
    url: '/hrApi/ownerRentRecord/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑房东交租记录
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/ownerRentRecord',
    method: 'post',
    data: data
  })
}

// 删除房东交租记录
export function deleteData(id) {
  return request({
    url: '/hrApi/ownerRentRecord/' + id,
    method: 'delete'
  })
}

// 检查是否存在未到期合同
export function checkPrevious(id) {
  return request({
    url: '/hrApi/ownerRentRecord/house/' + id,
    method: 'get'
  })
}

// 结束合同
export function endRentRecord(data) {
  return request({
    url: '/hrApi/ownerRentRecord/end',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/ownerRentRecord.js